import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import TeamRightRail from "./TeamRightRail";
import VirtualOfficeInviteBanner from "../../../components/VirtualOfficeInviteBanner";
import { TEAM_MOBILE_MEDIA_QUERY } from "../utils/teamUiUtils";

/**
 * Layout compartilhado: conteúdo + faixa de ferramentas à direita (Equipe, Tarefas, Agenda).
 */
export default function TeamWorkspaceLayout({
  children,
  basePath = "/equipe",
  activeSection = "chat",
  /** Páginas de lista rolam na área de conteúdo; o rail permanece em altura total. */
  contentScroll = false,
  /** Popup / janela sem MainLayout: exibe barra inferior no mobile. */
  standalone = false,
}) {
  const isMobile = useMediaQuery(TEAM_MOBILE_MEDIA_QUERY);
  const showRail = !isMobile || standalone;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        flex: 1,
        minHeight: 0,
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {standalone ? <VirtualOfficeInviteBanner /> : null}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: contentScroll ? "auto" : "hidden",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {children}
      </Box>

      {!showRail ? null : (
        <TeamRightRail
          basePath={basePath}
          activeSection={activeSection}
          isMobile={isMobile}
        />
      )}
    </Box>
  );
}
